webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MetalMarketHeader_vue__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Announcement_vue__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__MetalMarketHeader_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__Announcement_vue__["a"]; });











/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pricing; });
var pricing = {
  methods: {
    priceItem: function priceItem(spotPriceData, itemData) {
      var itemBid = null;
      var itemAsk = null;

      var dataCheck = true;

      var weigthOz = parseFloat(itemData.WC_OZWT);
      var bidPremium = parseFloat(itemData.premium_bid);
      var askPremium = parseFloat(itemData.premium_ask);

      if (typeof weigthOz === 'undefined' || weigthOz == null) {
        console.log('MISSING WEIGHT');
        dataCheck = false;
      }
      if (typeof bidPremium === 'undefined' || bidPremium == null) {
        console.log('MISSING BID PREMIUM');
        dataCheck = false;
      }
      if (typeof askPremium === 'undefined' || askPremium == null) {
        console.log('MISSING ASK PREMIUM');
        dataCheck = false;
      }

      if (typeof itemData.use_percent === 'undefined' || itemData.use_percent == null) {
        console.log('MISSING PERCENT FLAG');
        dataCheck = false;
      }
      if (typeof itemData.melt_plus === 'undefined' || itemData.melt_plus == null) {
        console.log('MISSING MELT FLAG');
        dataCheck = false;
      }
      if (typeof itemData.pricing_type === 'undefined' || itemData.pricing_type == null) {
        console.log('MISSING PRICING TYPE');
        dataCheck = false;
      }

      var pricingType = itemData.pricing_type;

      if (spotPriceData) {
        var currentSpotPrice = spotPriceData[pricingType];

        if (currentSpotPrice) {
          if (typeof currentSpotPrice.bid === 'undefined' || currentSpotPrice.bid == null) {
            console.log('MISSING SPOT BID');
            dataCheck = false;
          }
          if (typeof currentSpotPrice.ask === 'undefined' || currentSpotPrice.ask == null) {
            console.log('MISSING SPOT ASK');
            dataCheck = false;
          }
        } else {
          if (pricingType !== 'FIX') {
            console.log('MISSING SPOT PRICE DATA');
            dataCheck = false;
          }
        }

        if (dataCheck) {
          if (pricingType === 'FIX') {
            itemBid = bidPremium;
            itemAsk = askPremium;
          } else {
            if (currentSpotPrice) {
              if (itemData.use_percent) {
                itemBid = currentSpotPrice.bid * weigthOz * bidPremium;
                itemAsk = currentSpotPrice.ask * weigthOz * askPremium;
              } else {
                if (itemData.melt_plus) {
                  itemBid = currentSpotPrice.bid * weigthOz + bidPremium;
                  itemAsk = currentSpotPrice.ask * weigthOz + askPremium;
                } else {
                  itemBid = (currentSpotPrice.bid + bidPremium) * weigthOz;
                  itemAsk = (currentSpotPrice.ask + askPremium) * weigthOz;
                }
              }
            }
          }
        } else {
          console.log('PRICING DATA CHECK FAILED');
          console.log(itemData);
          console.log(currentSpotPrice);
        }

        if (itemBid && itemAsk) {
          var rnd = itemData.rounding ? parseFloat(itemData.rounding) : 0.01;
          itemBid = Math.round(itemBid / rnd) * rnd;
          itemAsk = Math.ceil(itemAsk / rnd) * rnd;
        }
      } else {
        console.log('MISSING SPOT PRICE DATA');
        dataCheck = false;
      }

      return {
        bid: itemBid,
        ask: itemAsk
      };
    }
  }
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_filters__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_MarketFull__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_dashboard_Dashboard__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_orders_OrderHistory__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_inventory_Inventory__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_pricing_Pricing__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_users_Users__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_setting_Setting__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_login_Login__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_resetPassword_ResetPassword__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SpotPrices_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_InventoryList_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_toasted__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_toasted__);



























__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('spot-prices', __WEBPACK_IMPORTED_MODULE_17__components_SpotPrices_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('inventory-list', __WEBPACK_IMPORTED_MODULE_18__components_InventoryList_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vue_toasted___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'Metal Market',
    component: __WEBPACK_IMPORTED_MODULE_8__containers_MarketFull__["a" /* default */],
    redirect: '/dashboard',
    children: [{
      path: '/dashboard',
      meta: {
        auth: ['ADMIN', 'CUST']
      },
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_9__views_dashboard_Dashboard__["a" /* default */]
    }, {
      path: '/orders',
      meta: {
        auth: ['ADMIN', 'CUST']
      },
      name: 'OrderHistory',
      component: __WEBPACK_IMPORTED_MODULE_10__views_orders_OrderHistory__["a" /* default */]
    }, {
      path: '/inventory',
      meta: {
        auth: ['ADMIN']
      },
      name: 'Inventory',
      component: __WEBPACK_IMPORTED_MODULE_11__views_inventory_Inventory__["a" /* default */]
    }, {
      path: '/pricing',
      meta: {
        auth: ['ADMIN']
      },
      name: 'Pricing',
      component: __WEBPACK_IMPORTED_MODULE_12__views_pricing_Pricing__["a" /* default */]
    }, {
      path: '/users',
      meta: {
        auth: ['ADMIN']
      },
      name: 'Users',
      component: __WEBPACK_IMPORTED_MODULE_13__views_users_Users__["a" /* default */]
    }, {
      path: '/setting',
      meta: {
        auth: ['ADMIN']
      },
      name: 'Setting',
      component: __WEBPACK_IMPORTED_MODULE_14__views_setting_Setting__["a" /* default */]
    }]
  }, {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_16__views_resetPassword_ResetPassword__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_15__views_login_Login__["a" /* default */]
  }, {
    path: '/403',
    name: 'Unauthorized',
    redirect: '/login'
  }]
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].router = router;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__webpack_require__(298), {
  auth: __webpack_require__(302),
  http: __webpack_require__(303),
  router: __webpack_require__(304)
});

if (false) {
  Vue.http.options.root = 'http://localhost:3000';
}
if (true) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.root = 'https://metalmarket.place';
}
if (false) {
  Vue.http.options.root = 'http://test.metalmarket.place';
}
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.credentials = true;

var EventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype, {
  $bus: {
    get: function get() {
      return EventBus;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]
  }
});

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8c1ceb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(169);
function injectStyle (ssrContext) {
  __webpack_require__(165)
  __webpack_require__(167)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8c1ceb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */,
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      quoteInterval: null,
      lastPriceCheck: null
    };
  },

  methods: {
    getSpotPrices: function getSpotPrices() {
      var _this = this;

      if (this.$auth.check()) {
        if (!this.lastPriceCheck || this.lastPriceCheck < Date.now() + 500) {
          this.$http.get('quote/all').then(function (response) {
            _this.$bus.$emit('spot-price', response.body);
          }, function (response) {
            console.log(response);
          });
        }
      }
    },
    userDetails: function userDetails() {
      var _this2 = this;

      if (this.$auth.check()) {
        this.$http.get('auth/userDetails').then(function (response) {
          if (response.body && response.body.message) {
            _this2.$router.push({ path: '/login' });
          }
        }, function (response) {
          console.log(response);
        });
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getSpotPrices();
  },
  mounted: function mounted() {
    var _this3 = this;

    this.quoteInterval = window.setInterval(function () {
      _this3.getSpotPrices();
      _this3.userDetails();
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.quoteInterval);
  },
  created: function created() {
    var _this4 = this;

    this.$bus.$on('request-spot-price', function ($event) {
      _this4.getSpotPrices();
    });
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"mode":"out-in"}},[(_vm.$auth.ready())?_c('div',[_c('router-view',{key:_vm.$route.path})],1):_vm._e()]),_vm._v(" "),(!_vm.$auth.ready())?_c('div',[_vm._v("\n    Loading ...\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 30,
	"./af.js": 30,
	"./ar": 31,
	"./ar-dz": 32,
	"./ar-dz.js": 32,
	"./ar-kw": 33,
	"./ar-kw.js": 33,
	"./ar-ly": 34,
	"./ar-ly.js": 34,
	"./ar-ma": 35,
	"./ar-ma.js": 35,
	"./ar-sa": 36,
	"./ar-sa.js": 36,
	"./ar-tn": 37,
	"./ar-tn.js": 37,
	"./ar.js": 31,
	"./az": 38,
	"./az.js": 38,
	"./be": 39,
	"./be.js": 39,
	"./bg": 40,
	"./bg.js": 40,
	"./bn": 41,
	"./bn.js": 41,
	"./bo": 42,
	"./bo.js": 42,
	"./br": 43,
	"./br.js": 43,
	"./bs": 44,
	"./bs.js": 44,
	"./ca": 45,
	"./ca.js": 45,
	"./cs": 46,
	"./cs.js": 46,
	"./cv": 47,
	"./cv.js": 47,
	"./cy": 48,
	"./cy.js": 48,
	"./da": 49,
	"./da.js": 49,
	"./de": 50,
	"./de-at": 51,
	"./de-at.js": 51,
	"./de-ch": 52,
	"./de-ch.js": 52,
	"./de.js": 50,
	"./dv": 53,
	"./dv.js": 53,
	"./el": 54,
	"./el.js": 54,
	"./en-au": 55,
	"./en-au.js": 55,
	"./en-ca": 56,
	"./en-ca.js": 56,
	"./en-gb": 57,
	"./en-gb.js": 57,
	"./en-ie": 58,
	"./en-ie.js": 58,
	"./en-nz": 59,
	"./en-nz.js": 59,
	"./eo": 60,
	"./eo.js": 60,
	"./es": 61,
	"./es-do": 62,
	"./es-do.js": 62,
	"./es.js": 61,
	"./et": 63,
	"./et.js": 63,
	"./eu": 64,
	"./eu.js": 64,
	"./fa": 65,
	"./fa.js": 65,
	"./fi": 66,
	"./fi.js": 66,
	"./fo": 67,
	"./fo.js": 67,
	"./fr": 68,
	"./fr-ca": 69,
	"./fr-ca.js": 69,
	"./fr-ch": 70,
	"./fr-ch.js": 70,
	"./fr.js": 68,
	"./fy": 71,
	"./fy.js": 71,
	"./gd": 72,
	"./gd.js": 72,
	"./gl": 73,
	"./gl.js": 73,
	"./gom-latn": 74,
	"./gom-latn.js": 74,
	"./he": 75,
	"./he.js": 75,
	"./hi": 76,
	"./hi.js": 76,
	"./hr": 77,
	"./hr.js": 77,
	"./hu": 78,
	"./hu.js": 78,
	"./hy-am": 79,
	"./hy-am.js": 79,
	"./id": 80,
	"./id.js": 80,
	"./is": 81,
	"./is.js": 81,
	"./it": 82,
	"./it.js": 82,
	"./ja": 83,
	"./ja.js": 83,
	"./jv": 84,
	"./jv.js": 84,
	"./ka": 85,
	"./ka.js": 85,
	"./kk": 86,
	"./kk.js": 86,
	"./km": 87,
	"./km.js": 87,
	"./kn": 88,
	"./kn.js": 88,
	"./ko": 89,
	"./ko.js": 89,
	"./ky": 90,
	"./ky.js": 90,
	"./lb": 91,
	"./lb.js": 91,
	"./lo": 92,
	"./lo.js": 92,
	"./lt": 93,
	"./lt.js": 93,
	"./lv": 94,
	"./lv.js": 94,
	"./me": 95,
	"./me.js": 95,
	"./mi": 96,
	"./mi.js": 96,
	"./mk": 97,
	"./mk.js": 97,
	"./ml": 98,
	"./ml.js": 98,
	"./mr": 99,
	"./mr.js": 99,
	"./ms": 100,
	"./ms-my": 101,
	"./ms-my.js": 101,
	"./ms.js": 100,
	"./my": 102,
	"./my.js": 102,
	"./nb": 103,
	"./nb.js": 103,
	"./ne": 104,
	"./ne.js": 104,
	"./nl": 105,
	"./nl-be": 106,
	"./nl-be.js": 106,
	"./nl.js": 105,
	"./nn": 107,
	"./nn.js": 107,
	"./pa-in": 108,
	"./pa-in.js": 108,
	"./pl": 109,
	"./pl.js": 109,
	"./pt": 110,
	"./pt-br": 111,
	"./pt-br.js": 111,
	"./pt.js": 110,
	"./ro": 112,
	"./ro.js": 112,
	"./ru": 113,
	"./ru.js": 113,
	"./sd": 114,
	"./sd.js": 114,
	"./se": 115,
	"./se.js": 115,
	"./si": 116,
	"./si.js": 116,
	"./sk": 117,
	"./sk.js": 117,
	"./sl": 118,
	"./sl.js": 118,
	"./sq": 119,
	"./sq.js": 119,
	"./sr": 120,
	"./sr-cyrl": 121,
	"./sr-cyrl.js": 121,
	"./sr.js": 120,
	"./ss": 122,
	"./ss.js": 122,
	"./sv": 123,
	"./sv.js": 123,
	"./sw": 124,
	"./sw.js": 124,
	"./ta": 125,
	"./ta.js": 125,
	"./te": 126,
	"./te.js": 126,
	"./tet": 127,
	"./tet.js": 127,
	"./th": 128,
	"./th.js": 128,
	"./tl-ph": 129,
	"./tl-ph.js": 129,
	"./tlh": 130,
	"./tlh.js": 130,
	"./tr": 131,
	"./tr.js": 131,
	"./tzl": 132,
	"./tzl.js": 132,
	"./tzm": 133,
	"./tzm-latn": 134,
	"./tzm-latn.js": 134,
	"./tzm.js": 133,
	"./uk": 135,
	"./uk.js": 135,
	"./ur": 136,
	"./ur.js": 136,
	"./uz": 137,
	"./uz-latn": 138,
	"./uz-latn.js": 138,
	"./uz.js": 137,
	"./vi": 139,
	"./vi.js": 139,
	"./x-pseudo": 140,
	"./x-pseudo.js": 140,
	"./yo": 141,
	"./yo.js": 141,
	"./zh-cn": 142,
	"./zh-cn.js": 142,
	"./zh-hk": 143,
	"./zh-hk.js": 143,
	"./zh-tw": 144,
	"./zh-tw.js": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 176;

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketFull_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13419612_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MarketFull_vue__ = __webpack_require__(252);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketFull_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13419612_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MarketFull_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["f" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    roles: ['ADMIN', 'CUST']
  }, {
    name: 'Orders',
    url: '/orders',
    icon: 'icon-layers',
    roles: ['ADMIN', 'CUST']
  }, {
    name: 'Inventory',
    url: '/inventory',
    icon: 'icon-list',
    roles: ['ADMIN']
  }, {
    name: 'Pricing',
    url: '/pricing',
    icon: 'icon-settings',
    roles: ['ADMIN']
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-people',
    roles: ['ADMIN']
  }, {
    name: 'Settings',
    url: '/setting',
    icon: 'icon-settings',
    roles: ['ADMIN']
  }]
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266b9736_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266b9736_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_pricing__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_pricing__["a" /* pricing */]],
  data: function data() {
    return {
      lock_items_buy: [],
      lock_items_sell: [],
      items_buy: [],
      items_sell: [],
      spot_prices: null,
      confirmScreen: false,
      successScreen: false,
      errorScreen: false,
      errorMessage: '',
      timerValue: 60,
      disabled: false,
      sites: [],
      sitePo: '',
      siteSo: '',
      sellingLimitExceed: [],
      buyingLimitExceed: []
    };
  },

  watch: {
    timerValue: function timerValue(newVal, oldVal) {
      if (newVal === 0) {
        this.priceLockedItems();
        this.timerValue = 60;
      }
    },
    items_buy: function items_buy(newVal, oldVal) {
      console.log('newVal, oldVal', newVal, oldVal);
      this.priceItems();
    },
    items_sell: function items_sell(newVal, oldVal) {
      this.priceItems();
    },
    spot_prices: function spot_prices(newVal, oldVal) {
      this.priceItems();
    }
  },
  computed: {
    total_lock_buy: function total_lock_buy() {
      var total = 0.0;
      for (var i = 0; i < this.lock_items_buy.length; i++) {
        total += this.lock_items_buy[i].total;
      }
      return total;
    },
    total_lock_sell: function total_lock_sell() {
      var total = 0.0;
      for (var i = 0; i < this.lock_items_sell.length; i++) {
        total += this.lock_items_sell[i].total;
      }
      return total;
    },
    total_buy: function total_buy() {
      var total = 0.0;
      for (var i = 0; i < this.items_buy.length; i++) {
        total += this.items_buy[i].total;
      }
      return total;
    },
    total_sell: function total_sell() {
      var total = 0.0;
      for (var i = 0; i < this.items_sell.length; i++) {
        total += this.items_sell[i].total;
      }
      return total;
    }
  },
  methods: {
    removeAllClose: function removeAllClose() {
      this.items_buy = [];
      this.items_sell = [];
      this.lock_items_buy = [];
      this.lock_items_sell = [];
      document.body.classList.add('aside-menu-hidden');
    },
    removeBuyItem: function removeBuyItem(index) {
      if (this.buyingLimitExceed.includes(this.items_buy[index].list_id)) {
        this.buyingLimitExceed.pop(this.items_buy[index].list_id);
      }
      this.items_buy.splice(index, 1);
    },
    removeSellItem: function removeSellItem(index) {
      if (this.sellingLimitExceed.includes(this.items_sell[index].list_id)) {
        this.sellingLimitExceed.pop(this.items_sell[index].list_id);
      }
      this.items_sell.splice(index, 1);
    },
    executeOrder: function executeOrder() {
      var _this = this;

      var orderPayload = {
        purchase_orders: this.lock_items_sell,
        sales_orders: this.lock_items_buy,
        site_po: this.lock_items_sell.length ? this.sitePo : '',
        site_so: this.lock_items_buy.length ? this.siteSo : '',
        user: this.$auth.user()
      };

      this.$http.post('order/execute', { order: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(orderPayload) }).then(function (response) {
        _this.items_buy = [];
        _this.items_sell = [];
        _this.lock_items_buy = [];
        _this.lock_items_sell = [];
        document.body.classList.add('aside-menu-hidden');
        _this.$bus.$emit('order-executed');
        var responseBody = response.body.status;
        if (responseBody === 'limit boundary error') {
          _this.errorScreen = true;
          _this.errorMessage = response.body.message;
        } else {
          _this.successScreen = true;
        }
      }, function (response) {
        console.log(response);
      });
    },
    lockAndConfirm: function lockAndConfirm() {
      if (this.sellingLimitExceed.length < 1 || this.buyingLimitExceed.length < 1) {
        this.priceLockedItems();
        this.timerValue = 60;
        this.confirmScreen = true;
      }
    },
    priceLockedItems: function priceLockedItems() {
      this.lock_items_buy = [];
      for (var i = 0; i < this.items_buy.length; i++) {
        this.lock_items_buy.push({
          list_id: this.items_buy[i].list_id,
          sales_desc: this.items_buy[i].sales_desc,
          quantity: this.items_buy[i].quantity > 0 ? this.items_buy[i].quantity : 1,
          price: this.items_buy[i].price_ask,
          total: (this.items_buy[i].quantity > 0 ? this.items_buy[i].quantity : 1) * this.items_buy[i].price_ask,
          limit_quantity: this.items_buy[i].limit_quantity,
          is_unlimited: this.items_buy[i].is_unlimited
        });
      }

      this.lock_items_sell = [];
      for (var j = 0; j < this.items_sell.length; j++) {
        console.log('priceLockedItems -> this.items_sell', this.items_sell);
        this.lock_items_sell.push({
          list_id: this.items_sell[j].list_id,
          sales_desc: this.items_sell[j].sales_desc,
          quantity: this.items_sell[j].quantity > 0 ? this.items_sell[j].quantity : 1,
          price: this.items_sell[j].price_bid,
          total: (this.items_sell[j].quantity > 0 ? this.items_sell[j].quantity : 1) * this.items_sell[j].price_bid,
          limit_quantity: this.items_sell[j].limit_quantity,
          is_unlimited: this.items_sell[j].is_unlimited
        });
      }
    },
    priceItems: function priceItems() {
      for (var j = 0; j < this.items_buy.length; j++) {
        var buyCurrentPrice = this.priceItem(this.spot_prices, this.items_buy[j]);
        this.items_buy[j].price_bid = buyCurrentPrice.bid.toFixed(2);
        this.items_buy[j].price_ask = buyCurrentPrice.ask.toFixed(2);
        this.items_buy[j].total = this.items_buy[j].quantity * this.items_buy[j].price_ask;
        if (parseInt(this.items_buy[j].quantity) > parseInt(this.items_buy[j].limit_quantity)) {
          if (this.buyingLimitExceed.includes(this.items_buy[j].list_id) || this.items_buy[j].is_unlimited) {} else {
            this.buyingLimitExceed.push(this.items_buy[j].list_id);
          }
        } else {
          if (this.buyingLimitExceed.includes(this.items_buy[j].list_id)) {
            this.buyingLimitExceed.pop(this.items_buy[j].list_id);
          }
        }
      }

      for (var i = 0; i < this.items_sell.length; i++) {
        var sellCurrentPrice = this.priceItem(this.spot_prices, this.items_sell[i]);
        this.items_sell[i].price_bid = sellCurrentPrice.bid.toFixed(2);
        this.items_sell[i].price_ask = sellCurrentPrice.ask.toFixed(2);
        this.items_sell[i].total = this.items_sell[i].quantity * this.items_sell[i].price_bid;
        if (parseInt(this.items_sell[i].quantity) > parseInt(this.items_sell[i].limit_quantity)) {
          if (this.sellingLimitExceed.includes(this.items_sell[i].list_id) || this.items_sell[i].is_unlimited) {} else {
            this.sellingLimitExceed.push(this.items_sell[i].list_id);
          }
        } else {
          if (this.sellingLimitExceed.includes(this.items_sell[i].list_id)) {
            this.sellingLimitExceed.pop(this.items_sell[i].list_id);
          }
        }
      }
    },
    addItemSell: function addItemSell(itemData) {
      var newItem = true;

      for (var i = 0; i < this.items_sell.length; i++) {
        if (this.items_sell[i].list_id === itemData.list_id) {
          newItem = false;
        }
      }

      if (newItem) {
        this.items_sell.unshift({
          list_id: itemData.list_id,
          sales_desc: itemData.sales_desc,
          price_bid: itemData.price_bid.toFixed(2),
          WC_OZWT: itemData.WC_OZWT,
          premium_bid: itemData.premium_bid,
          premium_ask: itemData.premium_ask,
          pricing_type: itemData.pricing_type,
          use_percent: itemData.use_percent,
          melt_plus: itemData.melt_plus,
          rounding: itemData.rounding,
          quantity: 1,
          total: itemData.price_bid.toFixed(2),
          limit_quantity: itemData.lc_quantity,
          is_unlimited: itemData.is_unlimited,
          premium_bid_percentage: (itemData.premium_bid + '').split('.')[1],
          premium_ask_percentage: (itemData.premium_ask + '').split('.')[1]
        });
      }
    },
    addItemBuy: function addItemBuy(itemData) {
      var newItem = true;

      for (var i = 0; i < this.items_buy.length; i++) {
        if (this.items_buy[i].list_id === itemData.list_id) {
          newItem = false;
        }
      }

      if (newItem) {
        this.items_buy.unshift({
          list_id: itemData.list_id,
          sales_desc: itemData.sales_desc,
          price_ask: itemData.price_ask.toFixed(2),
          WC_OZWT: itemData.WC_OZWT,
          premium_bid: itemData.premium_bid,
          premium_ask: itemData.premium_ask,
          pricing_type: itemData.pricing_type,
          use_percent: itemData.use_percent,
          melt_plus: itemData.melt_plus,
          rounding: itemData.rounding,
          quantity: 1,
          total: itemData.price_ask.toFixed(2),
          limit_quantity: itemData.lc_quantity,
          is_unlimited: itemData.is_unlimited,
          premium_bid_percentage: (itemData.premium_bid + '').split('.')[1],
          premium_ask_percentage: (itemData.premium_ask + '').split('.')[1]
        });
      }
    },
    getSites: function getSites() {
      var _this2 = this;

      this.$http.get('order/sites').then(function (response) {
        _this2.sites = response.body;
        _this2.disabled = _this2.sites.length ? _this2.disabled : !_this2.disabled;
        _this2.sitePo = _this2.sites.length ? _this2.sites[0].list_id : '';
        _this2.siteSo = _this2.sites.length ? _this2.sites[0].list_id : '';
      }, function (response) {
        console.log(response);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.$bus.$emit('request-spot-price');
    this.getSites();
  },
  mounted: function mounted() {
    var _this3 = this;

    this.quoteInterval = window.setInterval(function () {
      _this3.timerValue--;
    }, 1000);
  },
  created: function created() {
    var _this4 = this;

    this.$bus.$on('buy-item', function ($event) {
      _this4.addItemBuy($event);
    });
    this.$bus.$on('sell-item', function ($event) {
      _this4.addItemSell($event);
    });
    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this4.spot_prices = $event;
      }
    });
  }
});

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane show fade active",attrs:{"role":"tabpanel","aria-hidden":"false","aria-expanded":"true"}},[_c('b-button',{staticClass:"btn btn-danger btn-lg btn-block",attrs:{"type":"button","variant":"info"},on:{"click":function($event){_vm.lockAndConfirm()}}},[_vm._v("Lock Price & Confirm")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('div',{staticClass:"m-0 py-3 callout callout-success",staticStyle:{"border-bottom-width":"1px"}},[_c('div',[_vm._v("Buy Total: "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.total_buy)))])])]),_vm._v(" "),_c('div',{staticClass:"m-0 py-3 callout callout-primary"},[_c('div',[_vm._v("Sell Total: "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.total_sell)))])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_vm._l((_vm.items_buy),function(item,index){return _c('div',{staticClass:"m-0 py-1 callout callout-success",staticStyle:{"border-bottom-width":"1px"}},[_c('div',{staticStyle:{"padding-bottom":"7px"}},[_c('small',[_c('strong',[_vm._v(_vm._s(item.sales_desc))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"7px"}},[_c('small',[(item.limit_quantity < item.quantity && !item.is_unlimited)?_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Exceeds  ")]):_vm._e(),_vm._v("Max Quantity : "),(item.is_unlimited)?_c('strong',[_vm._v("Unlimited")]):_vm._e(),(! item.is_unlimited)?_c('strong',[_vm._v(_vm._s(item.limit_quantity))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",staticStyle:{"margin-bottom":"3px"},attrs:{"role":"group"}},[_vm._m(2,true),_vm._v(" "),(!item.is_unlimited)?_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control form-control-sm col-sm-8 text-center",attrs:{"min":"1","max":item.limit_quantity,"oninput":"validity.valid||(value='1')","type":"number"},domProps:{"value":(item.quantity)},on:{"keyup":function($event){_vm.priceItems()},"input":function($event){if($event.target.composing){ return; }item.quantity=$event.target.value}}})]):_vm._e(),_vm._v(" "),(item.is_unlimited)?_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control form-control-sm col-sm-8 text-center",attrs:{"type":"number","name":"quantity","min":"1","oninput":"validity.valid||(value='1')"},domProps:{"value":(item.quantity)},on:{"keyup":function($event){_vm.priceItems()},"input":function($event){if($event.target.composing){ return; }item.quantity=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.removeBuyItem(index)}}},[_c('i',{staticClass:"fa fa-remove"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"padding-bottom":"3px"}},[_c('small',[_vm._v(_vm._s(item.quantity)+" x "+_vm._s(_vm._f("currency")(item.price_ask))+" = "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(item.quantity * item.price_ask)))])])])])}),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_vm._l((_vm.items_sell),function(item,index){return _c('div',{staticClass:"m-0 py-1 callout callout-primary",staticStyle:{"border-bottom-width":"1px"}},[_c('div',{staticStyle:{"padding-bottom":"7px"}},[_c('small',[_c('strong',[_vm._v(_vm._s(item.sales_desc))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"7px"}},[_c('small',[(item.limit_quantity < item.quantity && !item.is_unlimited)?_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Exceeds  ")]):_vm._e(),_vm._v("Max Quantity : "),(item.is_unlimited)?_c('strong',[_vm._v("Unlimited")]):_vm._e(),(! item.is_unlimited)?_c('strong',[_vm._v(_vm._s(item.limit_quantity))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",staticStyle:{"margin-bottom":"3px"},attrs:{"role":"group"}},[_vm._m(4,true),_vm._v(" "),(!item.is_unlimited)?_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control form-control-sm col-sm-8 text-center",attrs:{"max":item.limit_quantity,"type":"number"},domProps:{"value":(item.quantity)},on:{"keyup":function($event){_vm.priceItems()},"input":function($event){if($event.target.composing){ return; }item.quantity=$event.target.value}}})]):_vm._e(),_vm._v(" "),(item.is_unlimited)?_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control form-control-sm col-sm-8 text-center",attrs:{"type":"number","name":"quantity"},domProps:{"value":(item.quantity)},on:{"keyup":function($event){_vm.priceItems()},"input":function($event){if($event.target.composing){ return; }item.quantity=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.removeSellItem(index)}}},[_c('i',{staticClass:"fa fa-remove"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"padding-bottom":"3px"}},[_c('small',[_vm._v(_vm._s(item.quantity)+" x "+_vm._s(_vm._f("currency")(item.price_bid))+" = "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(item.quantity * item.price_bid)))])])])])}),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.removeAllClose()}}},[_c('i',{staticClass:"fa fa-remove"})])])],2)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Order Confirmation","size":"lg","ok-disabled":_vm.disabled,"ok-title":"Execute Order"},on:{"ok":function($event){_vm.executeOrder()}},model:{value:(_vm.confirmScreen),callback:function ($$v) {_vm.confirmScreen=$$v},expression:"confirmScreen"}},[(_vm.lock_items_buy.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Prices locked for "+_vm._s(_vm.timerValue)+" seconds...")])])]):_vm._e(),_vm._v(" "),(_vm.lock_items_buy.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Sales Order")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Item")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.lock_items_buy),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(item.sales_desc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.price_ask)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.total)))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-right"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.siteSo),expression:"siteSo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.siteSo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sites),function(site){return _c('option',{domProps:{"value":site.list_id}},[_vm._v(_vm._s(site.name))])}))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"colspan":"2"}},[_vm._v("Purchase Total:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(_vm.total_lock_buy)))])])],2)])])]):_vm._e(),_vm._v(" "),(_vm.lock_items_sell.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Purchase Order")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Item")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.lock_items_sell),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(item.sales_desc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.price_bid)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.total)))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-right"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sitePo),expression:"sitePo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sitePo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sites),function(site){return _c('option',{domProps:{"value":site.list_id}},[_vm._v(_vm._s(site.name))])}))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"colspan":"2"}},[_vm._v("Sales Total:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(_vm.total_lock_sell)))])])],2)])])]):_vm._e()]),_vm._v(" "),_c('b-modal',{staticClass:"modal-success",attrs:{"title":"Order Complete","ok-only":"","size":"sm","ok-title":"Close"},model:{value:(_vm.successScreen),callback:function ($$v) {_vm.successScreen=$$v},expression:"successScreen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h4',[_vm._v("Thank you!")])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Order Incomplete","ok-only":"","size":"lg","ok-title":"Close"},model:{value:(_vm.errorScreen),callback:function ($$v) {_vm.errorScreen=$$v},expression:"errorScreen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v(_vm._s(_vm.errorMessage))])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase callout"},[_c('small',[_c('b',[_vm._v("Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase callout"},[_c('small',[_c('b',[_vm._v("You Are Buying")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label col-sm-5 text-right"},[_c('span',[_c('small',[_vm._v("Quantity :")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase callout"},[_c('small',[_c('b',[_vm._v("You Are Selling")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label col-sm-5 text-right"},[_c('span',[_c('small',[_vm._v("Quantity:")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313525a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(188);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313525a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656f121d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(191);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656f121d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbbc684_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(194);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbbc684_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"http://www.wilshirecoin.com/"}},[_vm._v("Metal Market")]),_vm._v(" © 2020 WC3 LP")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"https://www.skyhoundinternet.com/"}},[_vm._v("Skyhound Internet")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MetalMarketHeader_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_824a8386_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MetalMarketHeader_vue__ = __webpack_require__(198);
function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MetalMarketHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_824a8386_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MetalMarketHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  data: function data() {
    return {
      announcementStatus: 1
    };
  },

  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    logout: function logout() {
      this.$auth.logout({
        makeRequest: true,
        success: function success() {
          console.log('logged out');
        },
        redirect: '/login'
      });
    },
    setting: function setting() {
      this.$router.push({ path: '/setting' });
    },
    showAnnouncement: function showAnnouncement() {
      this.$bus.$emit('show-announcement');
    },
    getAnnouncementDetails: function getAnnouncementDetails() {
      var _this = this;

      console.log('getAnnouncementDetails -> getAnnouncementDetails');
      this.$http.get('admin/announcement-content').then(function (response) {
        _this.announcementStatus = parseInt(response.body[1]['setting_value']);
        console.log('getAnnouncementDetails -> this.announcementStatus', _this.announcementStatus);
      }, function (response) {
        console.log(response);
      });
    }
  },
  created: function created() {
    this.getAnnouncementDetails();
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('div',[_vm._v(_vm._s(_vm.announcementStatus))]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarMinimize}},[_vm._v("☰")]),_vm._v(" "),_c('b-nav',{staticClass:"ml-auto",attrs:{"is-nav-bar":""}},[(_vm.announcementStatus === 0)?_c('span',{staticStyle:{"background-color":"#34383c","border-bottom":"1px solid #34383c","cursor":"pointer"},attrs:{"title":"Announcement"},on:{"click":_vm.showAnnouncement}},[_c('span',{staticStyle:{"color":"white"}},[_c('i',{staticClass:"fa fa-bell"})])]):_vm._e(),_vm._v(" \n    "),_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$auth.user().name))]),_vm._v(" "),_c('b-nav-item-dropdown',{staticClass:"avatar",attrs:{"right":""}},[_c('template',{attrs:{"slot":"button-content"},slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/user.png","alt":""}})]),_vm._v(" "),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Account")])]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.logout()}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2)],1),_vm._v(" "),_c('button',{staticClass:"navbar-toggler aside-menu-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.asideToggle}},[_vm._v("☰")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acbf749_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(245);
function injectStyle (ssrContext) {
  __webpack_require__(200)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acbf749_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__ = __webpack_require__(242);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15638a78_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(204);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15638a78_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df92b4a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(207);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df92b4a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16809eb6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(210);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16809eb6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5055f87b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(213);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5055f87b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf99d0a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(216);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf99d0a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb6a0c38_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(220);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb6a0c38_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_url_external__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    linkExternal: function linkExternal() {
      return __WEBPACK_IMPORTED_MODULE_0_is_url_external___default()(this.url);
    }
  }
});

/***/ }),
/* 219 */,
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkExternal)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e98f6244_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(241);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e98f6244_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd66df06_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(244);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd66df06_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[(_vm.$auth.check(item.roles))?_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1):_vm._e()]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78c2a9d7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(248);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78c2a9d7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Announcement_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699debac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Announcement_vue__ = __webpack_require__(251);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Announcement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699debac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Announcement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'announcement',
  data: function data() {
    return {
      announcementModal: false,
      announcementContent: ''
    };
  },

  methods: {
    getAnnouncementDetails: function getAnnouncementDetails() {
      var _this = this;

      console.log('getAnnouncementDetails -> getAnnouncementDetails');
      this.$http.get('admin/announcement-content').then(function (response) {
        _this.announcementModal = true;
        _this.announcementContent = response.body[0]['setting_value'];
      }, function (response) {
        console.log(response);
      });
    },
    closeAnnouncement: function closeAnnouncement() {
      this.announcementModal = false;
      this.close();
    },
    close: function close() {
      console.log('close method called');
      this.$auth.user().is_update = 0;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$bus.$on('show-announcement', function ($event) {
      _this2.getAnnouncementDetails();
    });
  },
  beforeMount: function beforeMount() {
    console.log('beforeMount -> this.$auth.user()', this.$auth.user().is_update);

    if (this.$auth.user().is_update === 1) {
      this.userCheckedIn(this.$auth.user().id);
      this.getAnnouncementDetails();
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"announcement"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Announcement - Metal Market","ok-only":"","size":"lg"},on:{"ok":function($event){_vm.closeAnnouncement()}},model:{value:(_vm.announcementModal),callback:function ($$v) {_vm.announcementModal=$$v},expression:"announcementModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',[_vm._v("New Updates")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.announcementContent)}})])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51989cfc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(256);
function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51989cfc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_pricing__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_pricing__["a" /* pricing */]],
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      context: 'inventory context',
      inventory_config: {
        showFav: true,
        showName: true,
        showWeight: true,
        showInStock: false,

        showOrdered: false,
        showSalesOrder: false,
        showPricing: false,
        showBid: false,
        showCost: false,
        showAsk: false,
        showBuy: true,
        showSell: true,
        pageSize: 10,
        customerFilter: true
      },
      featured: [],
      favorites: [],
      currentSpot: null,
      showInventory: false,
      showFeatured: false,
      showFavorite: true,
      announcementModal: false,
      announcementContent: ''
    };
  },

  watch: {
    favorites: function favorites(newVal, oldVal) {
      this.priceItems();
    },
    featured: function featured(newVal, oldVal) {
      this.priceItems();
    },
    spot_prices: function spot_prices(newVal, oldVal) {
      this.priceItems();
    }
  },
  methods: {
    buyItem: function buyItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('buy-item', this.featured[index]);
    },
    sellItem: function sellItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('sell-item', this.featured[index]);
    },
    buyItemFav: function buyItemFav(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('buy-item', this.favorites[index]);
    },
    sellItemFav: function sellItemFav(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('sell-item', this.favorites[index]);
    },
    getFeatured: function getFeatured() {
      var _this = this;

      this.$http.get('inventory/featured').then(function (response) {
        _this.featured = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    getFavorites: function getFavorites() {
      var _this2 = this;

      this.$http.get('inventory/favorites').then(function (response) {
        _this2.favorites = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    priceItems: function priceItems() {
      for (var i = 0, len = this.featured.length; i < len; i++) {
        var currentPrice = this.priceItem(this.currentSpot, this.featured[i]);
        this.featured[i].price_bid = currentPrice.bid;
        this.featured[i].price_ask = currentPrice.ask;
      }

      for (var j = 0, leng = this.favorites.length; j < leng; j++) {
        var _currentPrice = this.priceItem(this.currentSpot, this.favorites[j]);
        this.favorites[j].price_bid = _currentPrice.bid;
        this.favorites[j].price_ask = _currentPrice.ask;
      }
    },
    userCheckedIn: function userCheckedIn(id) {
      this.$http.post('auth/setUpdate', { 'id': id }).then(function (response) {
        console.log(response);
      }, function (response) {
        console.log(response);
      });
    },
    getAnnouncementDetails: function getAnnouncementDetails() {
      var _this3 = this;

      console.log('getAnnouncementDetails -> getAnnouncementDetails');
      this.$http.get('admin/announcement-content').then(function (response) {
        _this3.announcementContent = response.body[0]['setting_value'];
        console.log('getAnnouncementDetails -> response.body', _this3.$auth.user());
      }, function (response) {
        console.log(response);
      });
    },
    closeAnnouncement: function closeAnnouncement() {
      this.announcementModal = false;
      this.close();
    },
    close: function close() {
      console.log('close method called');

      this.$auth.user().is_update = 0;
    }
  },
  created: function created() {
    var _this4 = this;

    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this4.currentSpot = $event;
        if (_this4.featured.length === 0) {
          _this4.getFeatured();
        }
        if (_this4.favorites.length === 0) {
          _this4.getFavorites();
        }
      } else {
        _this4.$bus.$emit('request-spot-price');
      }
    });
    this.$bus.$on('favorite-item', function ($event) {
      _this4.getFavorites();
    });
  },
  beforeMount: function beforeMount() {
    this.$bus.$emit('request-spot-price');
    console.log('beforeMount -> this.$auth.user()', this.$auth.user().is_update);

    if (this.$auth.user().is_update === 1) {
      this.announcementModal = true;
      this.userCheckedIn(this.$auth.user().id);
      this.getAnnouncementDetails();
    } else {
      this.getAnnouncementDetails();
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"15px"}},[_c('div',{staticClass:"col-xl-12"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.showFavorite },attrs:{"href":"#"},on:{"click":function($event){_vm.showInventory = false; _vm.showFeatured = false; _vm.showFavorite = true}}},[_vm._v("Favorites")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.showFeatured },attrs:{"href":"#"},on:{"click":function($event){_vm.showInventory = false; _vm.showFeatured = true; _vm.showFavorite = false}}},[_vm._v("Featured")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.showInventory },attrs:{"href":"#"},on:{"click":function($event){_vm.showInventory = true; _vm.showFeatured = false; _vm.showFavorite = false}}},[_vm._v("Inventory")])])])])]),_vm._v(" "),(_vm.showInventory)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('inventory-list',{attrs:{"inventory_config":_vm.inventory_config}})],1)]):_vm._e(),_vm._v(" "),(_vm.showFeatured)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.featured),function(item,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.purchase_desc))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dnb)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){_vm.sellItem(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_bid))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n                "+_vm._s((Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_bid))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+" \n              ")]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dns)?_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){_vm.buyItem(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_ask))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n                "+_vm._s((Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_ask))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+"\n              ")]):_vm._e()])])])}))])])]):_vm._e(),_vm._v(" "),(_vm.showFavorite)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.favorites),function(item,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.purchase_desc))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dnb)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){_vm.sellItemFav(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_bid))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n                "+_vm._s((Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_bid))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+" \n              ")]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dns)?_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){_vm.buyItemFav(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_ask))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n                "+_vm._s((Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_ask))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+"\n              ")]):_vm._e()])])])}))])])]):_vm._e(),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Announcement - Metal Market","ok-only":"","size":"lg"},on:{"ok":function($event){_vm.closeAnnouncement()}},model:{value:(_vm.announcementModal),callback:function ($$v) {_vm.announcementModal=$$v},expression:"announcementModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',[_vm._v("New Updates")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.announcementContent)}})])])])])])])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Featured Item")]),_vm._v(" "),_c('th',[_vm._v("Net Ava.")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Bid")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Ask")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Favorite Item")]),_vm._v(" "),_c('th',[_vm._v("Net Ava.")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Bid")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Ask")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderHistory_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d53edb9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_OrderHistory_vue__ = __webpack_require__(260);
function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d53edb9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_OrderHistory_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_pricing__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_pricing__["a" /* pricing */]],
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      context: 'order context',
      orderHistory: [],
      currentSpot: null
    };
  },

  watch: {
    orderHistory: function orderHistory(newVal, oldVal) {
      this.priceItems();
    },
    spot_prices: function spot_prices(newVal, oldVal) {
      this.priceItems();
    }
  },
  methods: {
    buyItem: function buyItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('buy-item', this.orderHistory[index]);
    },
    sellItem: function sellItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('sell-item', this.orderHistory[index]);
    },
    getOrderHistory: function getOrderHistory() {
      var _this = this;

      this.$http.get('order/history').then(function (response) {
        _this.orderHistory = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    priceItems: function priceItems() {
      for (var i = 0, len = this.orderHistory.length; i < len; i++) {
        var currentPrice = this.priceItem(this.currentSpot, this.orderHistory[i]);
        this.orderHistory[i].price_bid = currentPrice.bid;
        this.orderHistory[i].price_ask = currentPrice.ask;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this2.currentSpot = $event;
        if (_this2.orderHistory.length === 0) {
          _this2.getOrderHistory();
        }
      }
    });
    this.$bus.$on('order-executed', function ($event) {
      _this2.getOrderHistory();
    });
  },
  beforeMount: function beforeMount() {
    this.$bus.$emit('request-spot-price');
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.orderHistory),function(item,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("moment")(item.order_created,'MM-DD-YYYY HH:mm')))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[(item.status)?_c('div',[_vm._v("Submitted")]):_c('div',[_vm._v("Pending")])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.purchase_desc))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.order_type))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.rate)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.total)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dnb)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){_vm.sellItem(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_bid))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"})])]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dns)?_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){_vm.buyItem(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_ask))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"})])])])}))])])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Item")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Bid")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Ask")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventory_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c08825dc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Inventory_vue__ = __webpack_require__(263);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c08825dc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Inventory_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory',
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      context: 'inventory context',
      inventory_config: {
        showName: true,
        showWeight: true,
        showInStock: true,
        showOrdered: true,
        showSalesOrder: true,
        showPricing: true,
        showBid: true,
        showCost: true,
        showAsk: true,
        showBuy: false,
        showSell: false,
        pageSize: 10,
        customerFilter: false
      }
    };
  },
  created: function created() {
    document.body.classList.add('aside-menu-hidden');
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('inventory-list',{attrs:{"inventory_config":_vm.inventory_config}}),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e76c4b4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__ = __webpack_require__(266);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e76c4b4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pricing',
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      context: 'pricing context',
      adjustment: {
        gold_bid: 0.0,
        gold_ask: 0.0,
        silver_bid: 0.0,
        silver_ask: 0.0,
        palladium_bid: 0.0,
        palladium_ask: 0.0,
        platinum_bid: 0.0,
        platinum_ask: 0.0
      }
    };
  },

  methods: {
    savePrice: function savePrice() {
      this.$http.post('quote/adjust', this.adjustment).then(function (response) {
        console.log(response);
      }, function (response) {
        console.log(response);
      });
    },
    getAdjustments: function getAdjustments() {
      var _this = this;

      this.$http.get('quote/adjust', this.adjustment).then(function (response) {
        var adjData = JSON.parse(response.body);
        _this.adjustment.gold_bid = adjData['gold_bid'];
        _this.adjustment.gold_ask = adjData['gold_ask'];
        _this.adjustment.silver_bid = adjData['silver_bid'];
        _this.adjustment.silver_ask = adjData['silver_ask'];
        _this.adjustment.palladium_bid = adjData['palladium_bid'];
        _this.adjustment.palladium_ask = adjData['palladium_ask'];
        _this.adjustment.platinum_bid = adjData['platinum_bid'];
        _this.adjustment.platinum_ask = adjData['platinum_ask'];
      }, function (response) {
        console.log(response);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getAdjustments();
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"align-right"},[_vm._v("Gold")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.gold_bid),expression:"adjustment.gold_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.gold_bid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adjustment.gold_bid=$event.target.value}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.gold_ask),expression:"adjustment.gold_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.gold_ask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adjustment.gold_ask=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-right"},[_vm._v("Silver")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.silver_bid),expression:"adjustment.silver_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.silver_bid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adjustment.silver_bid=$event.target.value}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.silver_ask),expression:"adjustment.silver_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.silver_ask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adjustment.silver_ask=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-right"},[_vm._v("Platinum")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.platinum_bid),expression:"adjustment.platinum_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.platinum_bid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adjustment.platinum_bid=$event.target.value}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.platinum_ask),expression:"adjustment.platinum_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.platinum_ask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adjustment.platinum_ask=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-right"},[_vm._v("Palladium")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.palladium_bid),expression:"adjustment.palladium_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.palladium_bid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adjustment.palladium_bid=$event.target.value}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.palladium_ask),expression:"adjustment.palladium_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.palladium_ask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adjustment.palladium_ask=$event.target.value}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.savePrice()}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v("  Save Price Adjustment")])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Metal")]),_vm._v(" "),_c('th',[_vm._v("Bid")]),_vm._v(" "),_c('th',[_vm._v("Ask")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_434138ea_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(270);
function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_434138ea_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'accountList',
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      users: [],
      customers: [],
      vendors: [],
      currentUser: {},
      editScreen: false,
      resetMessage: '',
      resetError: false,
      isEditModeOn: false,
      deleteModal: false,
      storeDeleteModal: {},
      storeValueLimitModal: {},
      valueLimiterModal: false,
      modalLimit: {},
      freezeModal: false,
      storeFreezeModal: {},
      isGlobalFreeze: false
    };
  },

  methods: {
    newUser: function newUser() {
      this.currentUser = {};
      this.editScreen = true;
    },
    notifyWelcome: function notifyWelcome(index) {
      this.$http.post('admin/notify-welcome', this.users[index]).then(function (response) {
        console.log(response);
      }, function (response) {
        console.log(response);
      });
    },
    deleteIndex: function deleteIndex() {
      var _this = this;

      this.$toasted.show('Deleted User', {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 500
      });
      this.$http.post('admin/user-delete', this.storeDeleteModal).then(function (response) {
        _this.getUsers();
      }, function (response) {
        console.log(response);
      });
    },
    toggleModel: function toggleModel(index) {
      this.deleteModal = true;
      this.storeDeleteModal = this.users[index];
    },
    saveUser: function saveUser(index) {
      var _this2 = this;

      this.resetError = false;
      this.resetMessage = '';

      index.preventDefault();
      var _currentUser = this.currentUser,
          name = _currentUser.name,
          email = _currentUser.email;

      if (name === undefined || name === null || email === undefined || email === null || (this.currentUser.change_password === undefined || this.currentUser.change_password === null) && !this.isEditModeOn || this.currentUser.customer_list_id === undefined || this.currentUser.customer_list_id === null || this.currentUser.vendor_list_id === undefined || this.currentUser.vendor_list_id === null) {
        this.resetMessage = 'All field are madatory !!';
        this.resetError = true;
      }

      if (this.resetError === false && !this.isEditModeOn && (!this.currentUser.change_password.match(/[a-z]/g) || !this.currentUser.change_password.match(/[A-Z]/g) || !this.currentUser.change_password.match(/[0-9]/g) || !this.currentUser.change_password.match(/[^a-zA-Z\d]/g) || this.currentUser.change_password.length <= 8)) {
        this.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.';
        this.resetError = true;
      }

      if (this.isEditModeOn && this.currentUser.change_password && (!this.currentUser.change_password.match(/[a-z]/g) || !this.currentUser.change_password.match(/[A-Z]/g) || !this.currentUser.change_password.match(/[0-9]/g) || !this.currentUser.change_password.match(/[^a-zA-Z\d]/g) || this.currentUser.change_password.length <= 8)) {
        this.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.';
        this.resetError = true;
      }
      if (this.resetError === false && this.currentUser.id) {
        this.editScreen = false;
        this.isEditModeOn = false;
        this.$http.post('admin/user-save', this.currentUser).then(function (response) {
          _this2.getUsers();
        }, function (response) {
          console.log(response);
        });
      } else if (this.resetError === false) {
        this.isEditModeOn = false;
        this.editScreen = false;
        this.$http.post('admin/user-create', this.currentUser).then(function (response) {
          _this2.getUsers();
        }, function (response) {
          console.log(response);
        });
      }
    },
    editUser: function editUser(index) {
      this.currentUser = this.users[index];
      this.editScreen = true;
      this.isEditModeOn = true;
    },
    getUsers: function getUsers() {
      var _this3 = this;

      this.$http.get('admin/users').then(function (response) {
        _this3.users = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    getCustomers: function getCustomers() {
      var _this4 = this;

      this.$http.get('admin/customers').then(function (response) {
        _this4.customers = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    getVendors: function getVendors() {
      var _this5 = this;

      this.$http.get('admin/vendors').then(function (response) {
        _this5.vendors = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    openValueLimiter: function openValueLimiter(index) {
      var _this6 = this;

      this.storeValueLimitModal = this.users[index];
      this.valueLimiterModal = true;
      this.$http.post('admin/user-limit-detail', this.storeValueLimitModal).then(function (response) {
        if (response && response.body && response.body.success) {
          _this6.modalLimit = {
            purchase: response.data.data.purchase_limit,
            sales: response.data.data.sales_limit,
            enable: response.data.data.is_limit_enabled
          };
        }
      }, function (response) {
        console.log('openValueLimiter -> response', response);
      });
    },
    setSuspended: function setSuspended(index) {
      var _this7 = this;

      console.log('setSuspended -> this.users[index]', this.users[index]);
      var textSus = this.users[index].is_suspended ? 'Suspended' : 'Unsuspended';
      this.$http.post('admin/user-suspended', this.users[index]).then(function (response) {
        _this7.getUsers();
        _this7.$toasted.show(textSus, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 500
        });
      }, function (response) {
        console.log(response);
      });
    },
    saveValueLimiter: function saveValueLimiter() {
      var _this8 = this;

      this.valueLimiterModal = false;
      this.modalLimit.userId = this.storeValueLimitModal.id;
      this.modalLimit.purchase = this.modalLimit.purchase === '' ? 1 : this.modalLimit.purchase;
      this.modalLimit.sales = this.modalLimit.sales === '' ? 1 : this.modalLimit.sales;
      console.log('saveValueLimiter -> this.modalLimit', this.modalLimit);
      this.$http.post('admin/user-limit', this.modalLimit).then(function (response) {
        if (response && response.body && response.body.success) {
          _this8.$toasted.show('Value Limit setted successfully', {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000
          });
        } else {
          _this8.$toasted.show('Please set the limit value again !!', {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000
          });
        }
      }, function (response) {
        console.log(response);
      });
    },
    toggleFreezingModel: function toggleFreezingModel(index) {
      this.freezeModal = true;
      this.storeFreezeModal = this.users[index];
      this.freezeIndex();
    },
    freezeIndex: function freezeIndex() {
      var _this9 = this;

      this.$http.post('admin/user-freeze', this.storeFreezeModal).then(function (response) {
        console.log('freezeIndex -> this.storeFreezeModal.is_freeze', _this9.storeFreezeModal.is_freeze);
        var userFreezeText = _this9.storeFreezeModal.is_freeze === true ? 'Freeze' : 'Un-Freeze';
        _this9.$toasted.show(userFreezeText, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 500
        });
      }, function (response) {
        console.log(response);
      });
    },
    toggleFreezeGlobal: function toggleFreezeGlobal() {
      var _this10 = this;

      this.$http.post('admin/global-freeze', { 'trade_freezing': this.isGlobalFreeze }).then(function (response) {
        var setFreezeText = _this10.isGlobalFreeze ? 'Freezed' : 'Unfreezed';
        _this10.$toasted.show(setFreezeText, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 500
        });
      }, function (response) {
        console.log(response);
      });
    },
    getGlobalFreeze: function getGlobalFreeze() {
      var _this11 = this;

      this.$http.get('admin/global-freeze-details').then(function (response) {
        _this11.isGlobalFreeze = parseInt(response.body[0].setting_value);
      }, function (response) {
        console.log(response);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getUsers();
    this.getCustomers();
    this.getVendors();
    this.getGlobalFreeze();
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"row col-12"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.newUser()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("  New User")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row col-12"},[_c('div',{staticClass:"col-6",staticStyle:{"font-weight":"bold"}},[_vm._v("Freeze Trading Globally")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isGlobalFreeze),expression:"isGlobalFreeze"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isGlobalFreeze)?_vm._i(_vm.isGlobalFreeze,null)>-1:(_vm.isGlobalFreeze)},on:{"change":function($event){_vm.toggleFreezeGlobal()},"__c":function($event){var $$a=_vm.isGlobalFreeze,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isGlobalFreeze=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isGlobalFreeze=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isGlobalFreeze=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[(user.role == 'ADMIN')?_c('span',[_vm._v("Administrator")]):_vm._e(),_vm._v(" "),(user.role == 'CUST')?_c('span',[_vm._v("Customer")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(user.customer_name))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(user.vendor_name))]),_vm._v(" "),_c('td',[_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(user.is_suspended),expression:"user.is_suspended"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(user.is_suspended)?_vm._i(user.is_suspended,null)>-1:(user.is_suspended)},on:{"change":function($event){_vm.setSuspended(index)},"__c":function($event){var $$a=user.is_suspended,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(user.is_suspended=$$a.concat([$$v]))}else{$$i>-1&&(user.is_suspended=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{user.is_suspended=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100px"},attrs:{"type":"button"},on:{"click":function($event){_vm.openValueLimiter(index)}}},[_vm._v("Value Limiter")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100px"},attrs:{"type":"button"},on:{"click":function($event){_vm.editUser(index)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm",staticStyle:{"width":"100px"},attrs:{"type":"button"},on:{"click":function($event){_vm.notifyWelcome(index)}}},[_vm._v("Welcome")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-sm",staticStyle:{"width":"40px"},attrs:{"type":"button"},on:{"click":function($event){_vm.toggleModel(index)}}},[_c('i',{staticClass:"fa fa-times"})])])])}))])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary user-edit",attrs:{"title":"User","ok-title":"Save"},on:{"ok":_vm.saveUser},model:{value:(_vm.editScreen),callback:function ($$v) {_vm.editScreen=$$v},expression:"editScreen"}},[_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.resetMessage))]),_vm._v(" "),_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.name),expression:"currentUser.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"User Name"},domProps:{"value":(_vm.currentUser.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentUser.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-envelope"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.email),expression:"currentUser.email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Email Address"},domProps:{"value":(_vm.currentUser.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentUser.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-asterisk"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.change_password),expression:"currentUser.change_password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.currentUser.change_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentUser.change_password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-user-circle"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.customer_list_id),expression:"currentUser.customer_list_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentUser.customer_list_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.customers),function(customer,index){return _c('option',{domProps:{"value":customer.list_id}},[_vm._v(_vm._s(customer.name))])}))]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-user-circle-o"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.vendor_list_id),expression:"currentUser.vendor_list_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentUser.vendor_list_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.vendors),function(vendor,index){return _c('option',{domProps:{"value":vendor.list_id}},[_vm._v(_vm._s(vendor.name))])}))]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-lock"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.role),expression:"currentUser.role"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentUser.role=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"ADMIN"}},[_vm._v("Administrator")]),_vm._v(" "),_c('option',{attrs:{"value":"CUST"}},[_vm._v("Customer")])])]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Delete User","ok-title":"Delete","ok-only":"","size":"sm"},on:{"ok":function($event){_vm.deleteIndex()}},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v("Are you sure you want to delete ?")])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Value Limiter","ok-title":"Save","ok-only":"","size":"lg"},on:{"ok":function($event){_vm.saveValueLimiter()}},model:{value:(_vm.valueLimiterModal),callback:function ($$v) {_vm.valueLimiterModal=$$v},expression:"valueLimiterModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v("Set the value limiter for the account of "+_vm._s(_vm.storeValueLimitModal.name)+".")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',{staticClass:"align-center"},[_vm._v("Sales Credit Limit")]),_vm._v(" "),_c('th',{staticClass:"align-middle"},[_vm._v("Purchase Credit Limit")]),_vm._v(" "),_c('th',{staticClass:"align-middle"},[_vm._v("Enable")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalLimit.purchase),expression:"modalLimit.purchase"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},attrs:{"type":"number","min":"1","oninput":"validity.valid||(value='1')"},domProps:{"value":(_vm.modalLimit.purchase)},on:{"input":function($event){if($event.target.composing){ return; }_vm.modalLimit.purchase=$event.target.value}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalLimit.sales),expression:"modalLimit.sales"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},attrs:{"type":"number","min":"1","oninput":"validity.valid||(value='1')"},domProps:{"value":(_vm.modalLimit.sales)},on:{"input":function($event){if($event.target.composing){ return; }_vm.modalLimit.sales=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('label',{staticClass:"switch switch-3d switch-icon switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalLimit.enable),expression:"modalLimit.enable"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.modalLimit.enable)?_vm._i(_vm.modalLimit.enable,null)>-1:(_vm.modalLimit.enable)},on:{"__c":function($event){var $$a=_vm.modalLimit.enable,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.modalLimit.enable=$$a.concat([$$v]))}else{$$i>-1&&(_vm.modalLimit.enable=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.modalLimit.enable=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])])])])])])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Customer")]),_vm._v(" "),_c('th',[_vm._v("Vendor")]),_vm._v(" "),_c('th',[_vm._v("Suspended")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c2fa6ba_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__ = __webpack_require__(279);
function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c2fa6ba_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_editor__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Setting',
  data: function data() {
    return {
      htmlForEditor: '',
      isChecked: false,
      isDraft: false,
      checkPreviewAnnouncement: false
    };
  },

  methods: {
    saveHtml: function saveHtml() {
      this.$toasted.show('Saved announcement', {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 500
      });
      console.log('saveHtml -> htmlForEditor', this.htmlForEditor);
      this.$http.post('order/saveHtml', { 'content': this.htmlForEditor, 'mailOnEdit': this.isChecked, 'isDraft': this.isDraft }).then(function (response) {
        console.log('saveHtml -> response', response);
      }, function (response) {
        console.log(response);
      });
    },
    handleChangeCheck: function handleChangeCheck() {
      console.log('handleChangeCheck -> this.isChecked', this.isChecked);
    },
    getAnnouncementDetails: function getAnnouncementDetails() {
      var _this = this;

      this.$http.get('admin/announcement-content').then(function (response) {
        _this.htmlForEditor = response.body[0]['setting_value'];
        _this.isDraft = parseInt(response.body[1]['setting_value']);
        _this.isChecked = parseInt(response.body[2]['setting_value']);
      }, function (response) {
        console.log(response);
      });
    },
    toogleDraft: function toogleDraft() {},
    closePreviewAnnouncement: function closePreviewAnnouncement() {
      this.checkPreviewAnnouncement = false;
    },
    previewAccouncement: function previewAccouncement() {
      this.checkPreviewAnnouncement = true;
    }
  },
  beforeMount: function beforeMount() {
    this.getAnnouncementDetails();
  },

  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_0_vue2_editor__["a" /* VueEditor */],
    Announcement: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Announcement */]
  }
});

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row col-12",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"col-6",staticStyle:{"font-weight":"bold"}},[_vm._v("\n      Broadcast Announcement Message\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row col-12"},[_c('div',{staticClass:"col-2",staticStyle:{"font-weight":"bold"}},[_vm._v("Status: ")]),_vm._v(" "),_c('div',{staticClass:"col-9 row"},[_c('div',[_vm._v("ON")]),_vm._v(" \n          "),_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isDraft),expression:"isDraft"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isDraft)?_vm._i(_vm.isDraft,null)>-1:(_vm.isDraft)},on:{"change":function($event){_vm.toogleDraft()},"__c":function($event){var $$a=_vm.isDraft,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isDraft=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isDraft=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isDraft=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" \n          "),_c('div',[_vm._v("OFF")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('vue-editor',{attrs:{"id":"editor"},model:{value:(_vm.htmlForEditor),callback:function ($$v) {_vm.htmlForEditor=$$v},expression:"htmlForEditor"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-top":"20px","padding-right":"15px"}},[_c('div',{staticClass:"col-xl-6"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_c('tbody',[_c('tr',[_vm._m(0),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isChecked),expression:"isChecked"}],staticStyle:{"padding":"15px"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isChecked)?_vm._i(_vm.isChecked,null)>-1:(_vm.isChecked)},on:{"change":_vm.handleChangeCheck,"__c":function($event){var $$a=_vm.isChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isChecked=$$c}}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){_vm.previewAccouncement()}}},[_vm._v("Preview Announcement")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){_vm.saveHtml()}}},[_vm._v("Save")])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Preview Announcement - Metal Market","ok-only":"","size":"lg"},on:{"ok":function($event){_vm.closePreviewAnnouncement()}},model:{value:(_vm.checkPreviewAnnouncement),callback:function ($$v) {_vm.checkPreviewAnnouncement=$$v},expression:"checkPreviewAnnouncement"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',[_vm._v("Preview New Updates")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.htmlForEditor)}})])])])])])])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-center"},[_c('div',[_vm._v("E-mail notification to users")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72be4428_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(283);
function injectStyle (ssrContext) {
  __webpack_require__(281)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72be4428_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      context: 'login context',
      data: {
        body: {
          username: '',
          password: ''
        },
        loginMessage: 'Sign in to your account.',
        loginError: false,
        forgetPage: false,
        forgetError: false,
        forgetMessage: 'Enter your e-mail address so we can send you a password reset request',
        showMailButton: true
      },
      error: null
    };
  },

  methods: {
    login: function login() {
      this.$auth.login({
        body: this.data.body,
        redirect: '/dashboard',
        success: function success(res) {
          console.log('success -> res.body.data', res.body.data);
          this.$auth.token(null, res.body.data.id);
          this.$auth.user(res.body.data);
        },
        error: function error(res) {
          this.data.loginError = true;
          this.data.loginMessage = res.body.message;
          this.$auth.logout();
        }
      });
    },
    forgetPassword: function forgetPassword() {
      var _this = this;

      this.data.showMailButton = false;
      this.data.forgetMessage = 'Enter your e-mail address so we can send you a password reset request';
      this.data.forgetError = false;
      if (this.data.body.username === null || this.data.body.username === '') {
        this.data.forgetError = true;
        this.data.forgetMessage = 'Please enter email Id.';
        this.data.showMailButton = true;
      } else {
        this.$http.post('auth/sendForgetMail', { 'username': this.data.body.username }).then(function (response) {
          if (response.body.message && response.body.message.message) {
            _this.data.forgetMessage = 'This e-mail address is not currently registered.';
            _this.data.forgetError = true;
            _this.data.showMailButton = true;
          }
        }, function (response) {
          console.log(response);
        });
      }
    },
    switchToLoginPage: function switchToLoginPage() {
      this.data.forgetPage = false;
    },
    switchToForgetPage: function switchToForgetPage() {
      this.data.forgetPage = true;
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[(!_vm.data.forgetPage)?_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Login")]),_vm._v(" "),_c('p',{class:{ 'text-muted': !_vm.data.loginError, 'error-text': _vm.data.loginError }},[_vm._v(_vm._s(_vm.data.loginMessage))]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.username),expression:"data.body.username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.data.body.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.data.body.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.password),expression:"data.body.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.data.body.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.data.body.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){_vm.login()}}},[_vm._v("Login")])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn btn-link px-0",attrs:{"type":"button"},on:{"click":function($event){_vm.switchToForgetPage()}}},[_vm._v("Forgot password?")])])])]):_vm._e(),_vm._v(" "),(_vm.data.forgetPage)?_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Forget Password")]),_vm._v(" "),_c('p',{class:{ 'text-muted': !_vm.data.forgetError, 'error-text': _vm.data.forgetError }},[_vm._v(_vm._s(_vm.data.forgetMessage))]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.username),expression:"data.body.username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.data.body.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.data.body.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.data.showMailButton)?_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){_vm.forgetPassword()}}},[_vm._v("Send Mail")])]):_vm._e(),_vm._v(" "),(_vm.data.showMailButton)?_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn btn-link px-0",attrs:{"type":"button"},on:{"click":function($event){_vm.switchToLoginPage()}}},[_vm._v("Cancel")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[(!_vm.data.showMailButton)?_c('div',[_vm._m(3)]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_vm._m(4)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"success-text"},[_vm._v("An email has been sent with instructions on how to reset your password. It may take a few minutes to arrive. If you do not receive it, please check your spam filter.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-white bg-dark py-5 d-md-down-none",staticStyle:{"width":"44%"}},[_c('div',{staticClass:"card-body text-center"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__(284)}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "../../static/img/wc.17bc451.png";

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76399e6e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(288);
function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76399e6e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResetPassword',
  data: function data() {
    return {
      context: 'login context',
      data: {
        body: {
          username: '',
          password: '',
          resetPassword: ''
        },
        resetMessage: 'Reset your Password.',
        resetError: false,
        isHttpRequest: true
      }
    };
  },

  methods: {
    resetPasswordFunc: function resetPasswordFunc() {
      var _this = this;

      this.data.resetError = false;
      this.data.resetMessage = 'Reset your Password.';
      this.data.isHttpRequest = true;
      console.log('resetPasswordFunc -> this.data.body', this.data.body);
      if (this.data.body.password === null || this.data.body.password === '' || this.data.body.resetPassword === null || this.data.body.resetPassword === '' || this.data.body.username === null || this.data.body.username === '') {
        this.data.resetError = true;
        this.data.resetMessage = 'Please enter all fields as they are mandatory.';
        this.data.isHttpRequest = false;
      }
      var _data$body = this.data.body,
          password = _data$body.password,
          resetPassword = _data$body.resetPassword,
          username = _data$body.username;

      if (this.data.resetError === false && (!password.match(/[a-z]/g) || !password.match(/[A-Z]/g) || !password.match(/[0-9]/g) || !password.match(/[^a-zA-Z\d]/g) || password.length <= 8)) {
        this.data.resetError = true;
        this.data.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.';
        this.data.isHttpRequest = false;
      }
      if (this.data.resetError === false && password !== resetPassword) {
        this.data.resetError = true;
        this.data.resetMessage = 'Both Password should be Same !!';
        this.data.isHttpRequest = false;
      }
      if (this.data.isHttpRequest) {
        console.log('resetPasswordFunc -> username', username);
        var requestBody = {
          'token_mail': this.$route.query.test,
          'email': username,
          'password_hash': password
        };
        this.$http.post('auth/setResetPassword', requestBody).then(function (response) {
          console.log(_this.$router, response);
          if (response && response.status === 200) {
            _this.$router.push({ path: '/login' });
          }
        }, function (response) {
          console.log(response);
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    console.log('The id is: ' + this.$route.params.id);
    this.$http.post('auth/getMailId', { 'token_mail': this.$route.query.test }).then(function (response) {
      if (response.status === 200 && response.body.user !== null && response.body.user !== undefined) {
        console.log('11001' + response);
        _this2.data.body.username = response.body.user;
      } else {
        _this2.data.resetError = true;
        _this2.data.resetMessage = response.body.message;
      }
    }, function (response) {
      console.log(response);
    });
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{key:_vm.$route.params.id,staticClass:"card-body"},[_c('h1',[_vm._v("Reset Password")]),_vm._v(" "),_c('p',{class:{ 'text-muted': !_vm.data.resetError, 'error-text': _vm.data.resetError }},[_vm._v(_vm._s(_vm.data.resetMessage))]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.username),expression:"data.body.username"}],staticClass:"form-control",attrs:{"disabled":"","type":"text","placeholder":"Email"},domProps:{"value":(_vm.data.body.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.data.body.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.password),expression:"data.body.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.data.body.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.data.body.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.resetPassword),expression:"data.body.resetPassword"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Reset Password"},domProps:{"value":(_vm.data.body.resetPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.data.body.resetPassword=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){_vm.resetPasswordFunc()}}},[_vm._v("Reset Password")])])])])]),_vm._v(" "),_vm._m(3)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-white bg-dark py-5 d-md-down-none",staticStyle:{"width":"44%"}},[_c('div',{staticClass:"card-body text-center"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__(289)}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "../../static/img/wc.17bc451.png";

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpotPrices_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477225e2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SpotPrices_vue__ = __webpack_require__(292);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpotPrices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477225e2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SpotPrices_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spot-prices',
  data: function data() {
    return {
      spot_prices: null,
      gold_color_bid: 'black',
      gold_color_ask: 'black',
      silver_color_bid: 'black',
      silver_color_ask: 'black',
      platinum_color_bid: 'black',
      platinum_color_ask: 'black',
      palladium_color_bid: 'black',
      palladium_color_ask: 'black'
    };
  },

  methods: {
    getColor: function getColor(newVal, oldVal) {
      if (oldVal && newVal > oldVal) {
        return 'green';
      } else if (oldVal && newVal < oldVal) {
        return 'red';
      } else {
        return 'black';
      }
    },

    currentSpotPrice: function currentSpotPrice(symbol) {
      if (this.spot_prices && this.spot_prices[symbol]) {
        return this.spot_prices[symbol];
      } else {
        return { bid: null, ask: null };
      }
    }
  },
  watch: {
    spot_prices: function spot_prices(newVal, oldVal) {
      if (oldVal) {
        this.gold_color_bid = this.getColor(newVal['GOLD'].bid, oldVal['GOLD'].bid);
        this.gold_color_ask = this.getColor(newVal['GOLD'].ask, oldVal['GOLD'].ask);
        this.silver_color_bid = this.getColor(newVal['SILV'].bid, oldVal['SILV'].bid);
        this.silver_color_ask = this.getColor(newVal['SILV'].ask, oldVal['SILV'].ask);
        this.platinum_color_bid = this.getColor(newVal['PLAT'].bid, oldVal['PLAT'].bid);
        this.platinum_color_ask = this.getColor(newVal['PLAT'].ask, oldVal['PLAT'].ask);
        this.palladium_color_bid = this.getColor(newVal['PALL'].bid, oldVal['PALL'].bid);
        this.palladium_color_ask = this.getColor(newVal['PALL'].ask, oldVal['PALL'].ask);
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this.spot_prices = $event;
      }
    });
  },
  beforeMount: function beforeMount() {
    this.$bus.$emit('request-spot-price');
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tr',[_c('th',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#EEE8AA","width":"110px"}},[_vm._v("Gold")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.gold_color_bid })},[_vm._v("Bid:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('GOLD').bid)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.gold_color_ask })},[_vm._v("Ask:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('GOLD').ask)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tr',[_c('th',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#BCC6CC","width":"110px"}},[_vm._v("Silver")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.silver_color_bid })},[_vm._v("Bid:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('SILV').bid)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.silver_color_ask })},[_vm._v("Ask:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('SILV').ask)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tr',[_c('th',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#E5E4E2","width":"110px"}},[_vm._v("Platinum")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.platinum_color_bid })},[_vm._v("Bid:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('PLAT').bid)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.platinum_color_ask })},[_vm._v("Ask:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('PLAT').ask)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tr',[_c('th',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#CED0DD","width":"110px"}},[_vm._v("Palladium")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.palladium_color_bid })},[_vm._v("Bid:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('PALL').bid)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.palladium_color_ask })},[_vm._v("Ask:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('PALL').ask)))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryList_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21940d72_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryList_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21940d72_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_pricing__ = __webpack_require__(12);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_pricing__["a" /* pricing */]],
  props: {
    inventory_config: { default: null }
  },
  data: function data() {
    return {
      categories: [],
      categoryFilter: '',
      items: [],
      allItems: [],
      currentPage: 0,
      spot_prices: null
    };
  },

  computed: {
    pages: function pages() {
      var currentPages = [];
      for (var i = 0; i < this.allItems.length / this.inventory_config.pageSize; i++) {
        currentPages.push({ name: i + 1, active: i === this.currentPage });
      }
      return currentPages;
    }
  },
  filters: {
    formatWeight: function formatWeight(value) {
      if (!value) return '';
      return parseFloat(value).toFixed(6);
    },
    formatMissing: function formatMissing(value) {
      if (!value) return '—';
      if (value === '') return '—';
      return value;
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      this.priceItems();
    },
    spot_prices: function spot_prices(newVal, oldVal) {
      this.priceItems();
    }
  },
  methods: {
    favorite: function favorite(itemIndex) {
      var _this = this;

      this.$http.post('inventory/favorite', this.items[itemIndex]).then(function (response) {
        _this.$bus.$emit('favorite-item', _this.items[itemIndex]);
      }, function (response) {
        console.log(response);
      });
    },
    buyItem: function buyItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('buy-item', this.items[index]);
    },
    sellItem: function sellItem(index) {
      console.log('sellItem -> this.items[index]', this.items[index]);
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('sell-item', this.items[index]);
    },
    setPage: function setPage(pageNum) {
      var maxPage = parseInt(this.allItems.length / this.inventory_config.pageSize);

      if (pageNum < 0) {
        this.currentPage = 0;
      } else if (pageNum > maxPage) {
        this.currentPage = maxPage;
      } else {
        this.currentPage = pageNum;
      }

      var pageStart = this.currentPage * this.inventory_config.pageSize;
      var pageEnd = pageStart + this.inventory_config.pageSize - 1;
      this.items = this.allItems.slice(pageStart, pageEnd);
    },
    getInventory: function getInventory() {
      var _this2 = this;

      this.$http.get('inventory/search', { params: { category: this.categoryFilter, customer: this.inventory_config.customerFilter } }).then(function (response) {
        _this2.allItems = response.body;
        _this2.items = _this2.allItems.slice(0, _this2.inventory_config.pageSize);
        _this2.currentPage = 0;
      }, function (response) {
        console.log(response);
      });
    },
    priceItems: function priceItems() {
      for (var i = 0, len = this.items.length; i < len; i++) {
        console.log('priceItems -> this.items[i]', this.items[i]);
        var currentPrice = this.priceItem(this.spot_prices, this.items[i]);
        this.items[i].price_bid = currentPrice.bid;
        this.items[i].price_ask = currentPrice.ask;
      }
    },
    calculatePricing: function calculatePricing(index) {
      console.log('calculatePricing -> index', index);
      var currentPrice = this.priceItem(this.spot_prices, this.items[index]);
      this.items[index].price_bid = currentPrice.bid;
      this.items[index].price_ask = currentPrice.ask;
    },
    saveItem: function saveItem(itemIndex) {
      var _this3 = this;

      this.$http.post('inventory/save', this.items[itemIndex]).then(function (response) {
        _this3.items[itemIndex].modified = false;
      }, function (response) {
        console.log(response);
      });
    },
    setModified: function setModified(itemIndex) {
      this.items[itemIndex].modified = true;
      console.log('setModified -> this.items[itemIndex]', this.items[itemIndex]);
    },
    getCategories: function getCategories() {
      var _this4 = this;

      this.$http.get('inventory/categories').then(function (response) {
        _this4.categories = response.body;
      }, function (response) {
        console.log(response);
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this5.spot_prices = $event;
        if (_this5.allItems.length === 0) {
          _this5.getInventory();
        }
      } else {
        _this5.$bus.$emit('request-spot-price');
      }
    });
  },
  beforeMount: function beforeMount() {
    this.getInventory();
    this.getCategories();
    this.$bus.$emit('request-spot-price');
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryFilter),expression:"categoryFilter"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getInventory()}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Categories")]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('option',{domProps:{"value":category.value}},[(category.level === 2)?_c('p',[_vm._v("  •")]):_vm._e(),_vm._v(" "),(category.level === 3)?_c('p',[_vm._v("      ▸")]):_vm._e(),_vm._v("\n        "+_vm._s(category.name)+"\n      ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-xl-9"},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){_vm.setPage(_vm.currentPage - 1)}}},[_vm._v("Prev")])]),_vm._v(" "),_vm._l((_vm.pages),function(page,index){return _c('li',{staticClass:"page-item",class:{ active: page.active }},[(index >= _vm.currentPage - 5 && (index < _vm.currentPage + 5 || index < 10))?_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){_vm.setPage(index)}}},[_vm._v(_vm._s(page.name))]):_vm._e()])}),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){_vm.setPage(_vm.currentPage + 1)}}},[_vm._v("Next")])])],2)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 row flex-row flex-nowrap"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_c('thead',[_c('tr',[(_vm.inventory_config.showFav)?_c('th',[_vm._v("Fav")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showName)?_c('th',[_vm._v("Item Name")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showWeight)?_c('th',[_vm._v("Wgt (oz)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showInStock)?_c('th',[_vm._v("Avail")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showOrdered)?_c('th',[_vm._v("Ord")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSalesOrder)?_c('th',[_vm._v("SO")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showWeight)?_c('th',[_vm._v("Net Ava.")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Show")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("DNS")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("DNB")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Feat")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Melt+")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("UQ∞")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("QL")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("QTY (QL)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Pricing")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Bid (Prm)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Ask (Prm)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',{staticClass:"text-center"},[_vm._v("%")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Round")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showBid)?_c('th',{staticClass:"text-right"},[_vm._v("Bid (Price)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showCost)?_c('th',{staticClass:"text-right"},[_vm._v("Avg Cost")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showAsk)?_c('th',{staticClass:"text-right"},[_vm._v("Ask (Price)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th'):_vm._e(),_vm._v(" "),(_vm.inventory_config.showBuy)?_c('th',{staticClass:"text-center"},[_vm._v("Bid")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSell)?_c('th',{staticClass:"text-center"},[_vm._v("Ask")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',[(_vm.inventory_config.showFav)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-icon switch-primary",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.fav),expression:"item.fav"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.fav)?_vm._i(item.fav,null)>-1:(item.fav)},on:{"change":function($event){_vm.favorite(index)},"__c":function($event){var $$a=item.fav,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.fav=$$a.concat([$$v]))}else{$$i>-1&&(item.fav=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.fav=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showName)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.sales_desc))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showWeight)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("formatWeight")(item.WC_OZWT)))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showWeight)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_hand))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showOrdered)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_order))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSalesOrder)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_sales_order))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSalesOrder)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-success",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.display),expression:"item.display"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.display)?_vm._i(item.display,null)>-1:(item.display)},on:{"change":function($event){_vm.setModified(index)},"__c":function($event){var $$a=item.display,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.display=$$a.concat([$$v]))}else{$$i>-1&&(item.display=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.display=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.dns),expression:"item.dns"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.dns)?_vm._i(item.dns,null)>-1:(item.dns)},on:{"change":function($event){_vm.setModified(index)},"__c":function($event){var $$a=item.dns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.dns=$$a.concat([$$v]))}else{$$i>-1&&(item.dns=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.dns=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.dnb),expression:"item.dnb"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.dnb)?_vm._i(item.dnb,null)>-1:(item.dnb)},on:{"change":function($event){_vm.setModified(index)},"__c":function($event){var $$a=item.dnb,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.dnb=$$a.concat([$$v]))}else{$$i>-1&&(item.dnb=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.dnb=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-primary",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.feature),expression:"item.feature"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.feature)?_vm._i(item.feature,null)>-1:(item.feature)},on:{"change":function($event){_vm.setModified(index)},"__c":function($event){var $$a=item.feature,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.feature=$$a.concat([$$v]))}else{$$i>-1&&(item.feature=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.feature=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-dark",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.melt_plus),expression:"item.melt_plus"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.melt_plus)?_vm._i(item.melt_plus,null)>-1:(item.melt_plus)},on:{"change":function($event){_vm.setModified(index) | _vm.calculatePricing(index)},"__c":function($event){var $$a=item.melt_plus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.melt_plus=$$a.concat([$$v]))}else{$$i>-1&&(item.melt_plus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.melt_plus=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-success",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.is_unlimited),expression:"item.is_unlimited"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.is_unlimited)?_vm._i(item.is_unlimited,null)>-1:(item.is_unlimited)},on:{"change":function($event){_vm.setModified(index)},"__c":function($event){var $$a=item.is_unlimited,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.is_unlimited=$$a.concat([$$v]))}else{$$i>-1&&(item.is_unlimited=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.is_unlimited=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-success",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.is_lc),expression:"item.is_lc"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.is_lc)?_vm._i(item.is_lc,null)>-1:(item.is_lc)},on:{"change":function($event){_vm.setModified(index)},"__c":function($event){var $$a=item.is_lc,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.is_lc=$$a.concat([$$v]))}else{$$i>-1&&(item.is_lc=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.is_lc=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.lc_quantity),expression:"item.lc_quantity",modifiers:{"number":true}}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},attrs:{"min":"0","type":"number"},domProps:{"value":(item.lc_quantity)},on:{"keyup":function($event){_vm.setModified(index)},"input":function($event){if($event.target.composing){ return; }item.lc_quantity=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.pricing_type),expression:"item.pricing_type"}],staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); item.pricing_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.calculatePricing(index) | _vm.setModified(index)}]}},[_c('option',{attrs:{"value":"FIX"}},[_vm._v("Fixed")]),_vm._v(" "),_c('option',{attrs:{"value":"GOLD"}},[_vm._v("Gold")]),_vm._v(" "),_c('option',{attrs:{"value":"SILV"}},[_vm._v("Silver")]),_vm._v(" "),_c('option',{attrs:{"value":"PLAT"}},[_vm._v("Platinum")]),_vm._v(" "),_c('option',{attrs:{"value":"PALL"}},[_vm._v("Palladium")])])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.premium_bid),expression:"item.premium_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(item.premium_bid)},on:{"keyup":function($event){_vm.calculatePricing(index) | _vm.setModified(index)},"input":function($event){if($event.target.composing){ return; }item.premium_bid=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.premium_ask),expression:"item.premium_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(item.premium_ask)},on:{"keyup":function($event){_vm.calculatePricing(index) | _vm.setModified(index)},"input":function($event){if($event.target.composing){ return; }item.premium_ask=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle text-center"},[_c('label',{staticClass:"switch switch-text switch-dark",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.use_percent),expression:"item.use_percent"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.use_percent)?_vm._i(item.use_percent,null)>-1:(item.use_percent)},on:{"change":function($event){_vm.setModified(index) | _vm.calculatePricing(index)},"__c":function($event){var $$a=item.use_percent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(item.use_percent=$$a.concat([$$v]))}else{$$i>-1&&(item.use_percent=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{item.use_percent=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"%","data-off":"$"}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.rounding),expression:"item.rounding"}],staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); item.rounding=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.calculatePricing(index) | _vm.setModified(index)}]}},[_c('option',{attrs:{"value":"0.01"}},[_vm._v(".01")]),_vm._v(" "),_c('option',{attrs:{"value":"0.05"}},[_vm._v(".05")]),_vm._v(" "),_c('option',{attrs:{"value":"0.1"}},[_vm._v(".10")]),_vm._v(" "),_c('option',{attrs:{"value":"0.25"}},[_vm._v(".25")]),_vm._v(" "),_c('option',{attrs:{"value":"0.5"}},[_vm._v(".50")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1.00")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5.00")])])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showBid)?_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.price_bid)))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showCost)?_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("formatMissing")(_vm._f("currency")(item.average_cost))))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showAsk)?_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.price_ask)))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle text-right"},[(item.modified)?_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.saveItem(index)}}},[_vm._v("Save")]):_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"type":"button","disabled":true}},[_vm._v("Save")])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showBuy)?_c('td',{staticClass:"align-middle text-center"},[(item.dnb)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n            Please Call\n          ")]):_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){_vm.sellItem(index)}}},[_vm._v("\n            "+_vm._s(_vm._f("currency")(item.price_bid))+"\n              "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n              "+_vm._s((Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_bid))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+" \n            ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSell)?_c('td',{staticClass:"align-middle text-center"},[(item.dns)?_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n            Please Call\n          ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){_vm.buyItem(index)}}},[_vm._v("\n            "+_vm._s(_vm._f("currency")(item.price_ask))+"\n              "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n              "+_vm._s((Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_ask))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+"\n            ")]):_vm._e()])]):_vm._e()])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[150]);


// WEBPACK FOOTER //
// static/js/app.ebcfb2184de44cabe122.js